import client from './client';
import type { ApiResponse, Group, Target } from '../types';

interface CreateGroupRequest {
  name: string;
  targets: Omit<Target, 'id'>[];
}

export const groupsApi = {
  // Go returns a bare Group[] (not { data: [...] }).
  getAll: () =>
    client.get<Group[]>('/groups/'),

  getById: (id: number) =>
    client.get<Group>(`/groups/${id}`),

  getSummary: () =>
    client.get<{ total: number; groups: Group[] }>('/groups/summary'),

  create: (data: CreateGroupRequest) =>
    client.post<Group>('/groups/', data),

  // Go's PutGroup requires the body's id to match the URL id.
  update: (id: number, data: Partial<CreateGroupRequest>) =>
    client.put<Group>(`/groups/${id}`, { ...data, id }),

  delete: (id: number) =>
    client.delete<ApiResponse<null>>(`/groups/${id}`),

  importCSV: (csvData: string) =>
    client.post<Group[]>('/import/group', { csv: csvData }),
};
